import QuestionMark from "@/components/Icons/customIcons/QuestionMark"
import FAQItem from "@/components/pages/HelpPage/FAQItem"
import { ContactForm } from "@/components/pages/HelpPage/HelpPage"
import Container from "@/components/shared/Container"
import { ROUTES } from "@/conf"
import Link from "next/link"
import { Trans, useTranslation } from "react-i18next"
import SEO from "../../core/SEO"
import Typography from "../../shared/Typography"

const FAQ_ITEMS = [
  "help_one",
  "help_two",
  "help_three",
  "help_four",
  "help_five",
  "help_six",
  "help_seven",
  "help_eight",
  "help_nine",
  "help_ten",
  "help_eleven",
  "help_twelve",
  "help_thirteen",
  "help_fourteen",
  "help_fifteen",
  "help_sixteen",
  "help_seventeen",
  "help_eighteen",
] as const

const HelpPage = () => {
  const { t } = useTranslation()

  return (
    <Container className="pb-16 pt-20">
      <SEO
        title="Nápověda - Když nevíte tak se zeptejte!"
        description="Inspirujte se dotazy ostatních a využite potenciál aplikace naplno. Neztrácejte energii a neobjevujte znvou již objevené."
      />

      <div className="ml-[-25px] flex flex-row items-center gap-4">
        <QuestionMark />

        <div className="flex flex-col ">
          <Typography tag="h1" type="h1" className="text-primary-50 ">
            {t("help.title")}
          </Typography>

          <Typography type="l" className="pt-4 text-primary-200">
            {t("help.subtitle")}
          </Typography>
        </div>
      </div>

      <div className="flex flex-col gap-8 pt-20 sm:flex-row sm:gap-[112px]">
        <div className="lg:w-1/2">
          <Typography type="h2" className="pb-6 text-primary-50">
            {t("help.faq")}
          </Typography>

          <div className="flex flex-col gap-4">
            {FAQ_ITEMS.map((item) => (
              <FAQItem
                key={item}
                question={t(`help.${item}.title`)}
                answer={
                  <Trans
                    i18nKey={`help.${item}.subtitle`}
                    t={t}
                    components={{
                      map: <Link className="cursor-pointer text-secondary-300" href={ROUTES.map} />,
                      tournament: <Link className="cursor-pointer text-secondary-300" href={ROUTES.tournament} />,
                      br: <br />,
                      bold: <span className="font-bold" />,
                    }}
                  />
                }
              />
            ))}
          </div>
        </div>
        <div className="lg:w-1/2">
          <ContactForm />
        </div>
      </div>
    </Container>
  )
}

export default HelpPage
